import React from 'react';

import PageLayout from 'src/app/v1/views/layouts/PageLayout';

import { NotificationsSettingSteps } from './components/NotificationsSettingSteps';

export const NotificationsSetting = () => (
  <PageLayout isContentFullWidth>
    <NotificationsSettingSteps />
  </PageLayout>
);
